import type { Awareness } from 'y-protocols/awareness';

import { getExperimentValue } from '@canvas/client-feature-flags/experiments';
import type { AwarenessContainer } from '@canvas/connection';
import { AwarenessChannel } from '@canvas/model/awareness';

export const getAgentParticipantAwarenessForFacepile = (
  awarenessContainer: AwarenessContainer
): Awareness | undefined => {
  const isDatabaseBEStreamingEnabled = getExperimentValue(
    'databaseBEStreaming',
    'enabled',
    { fireExperimentExposure: false }
  );

  return isDatabaseBEStreamingEnabled
    ? awarenessContainer.getAwareness(AwarenessChannel.Participants)
    : undefined;
};
